export const TRACK_PAGE_APPOINTMENTCALENDAR = 'PageAppointmentCalendar';
export const TRACK_PAGE_APPOINTMENTPERSONALDATA = 'PageAppointmentPersonalData';
export const TRACK_PAGE_BOOKING = 'PageBooking';
export const TRACK_SUBMIT_BOOKING = 'SubmitBooking';
export const TRACK_CANCEL_BOOKING = 'CancelBooking';
export const TRACK_POPUP_BOOKINGCODE = 'PopupBookingCode';
export const TRACK_CANCEL_BOOKINGCODE = 'CancelBookingCode';
export const TRACK_SUBMIT_BOOKINGCODE = 'SubmitBookingCode';
export const TRACK_PAGE_APPOINTMENT_CATEGORY_DEPARTMENT = 'PageChooseDepartment';
export const TRACK_PAGE_APPOINTMENT_CATEGORY_EXTENDEDPHYSICIAN = 'PageChooseAppointmentPhysician';
export const TRACK_PAGE_APPOINTMENT_CATEGORY_PHYSICIAN = 'PageChoosePhysician';
export const TRACK_PAGE_APPOINTMENT_CATEGORY_REASON = 'PageChooseReason';
export const TRACK_POPUP_BIRTHDAY2FA = 'PopupBirthday2FA';
export const TRACK_CANCEL_BIRTHDAY2FA = 'CancelBirthday2FA';
export const TRACK_SUBMIT_BIRTHDAY2FA = 'SubmitBirthday2FA';

/* BEISPIELE TRackConfiguration[15] in Principa */
/*

TrackingConfiguration(java.util.Map data) ::= <<{
   "data": [
    {
      "id": "PageAppointmentCalendar",
      "event": "page_appointment_calendar",
      "action": "page_view",
      "label": "Termin waehlen"
    },
    {
      "id": "PageAppointmentPersonalData",
      "event": "page_appointment_personal_data",
      "action": "page_view",
      "label": "Personendaten"
    },
    {
      "id": "PageBooking",
      "event": "page_booking",
      "action": "page_view",
      "label": "Termin buchen"
    },
    {
      "id": "SubmitBooking",
      "event": "submit_booking",
      "action": "submit",
      "label": "Jetzt buchen"
    },
    {
      "id": "CancelBooking",
      "event": "cancel_booking",
      "action": "click",
      "label": "Termin buchen abbrechen"
    },
    {
      "id": "PopupBookingCode",
      "event": "popup_booking_code",
      "action": "popup_view",
      "label": "Buchungscode"
    },
    {
      "id": "SubmitBookingCode",
      "event": "submit_booking_code",
      "action": "submit",
      "label": "Buchungscode absenden"
    },
    {
      "id": "CancelBookingCode",
      "event": "cancel_booking_code",
      "action": "click",
      "label": "Buchungscode abbrechen"
    },
    {
      "id": "PageChooseDepartment",
      "event": "page_choose_department",
      "action": "page_view",
      "label": "Fachrichtung waehlen"
    },
    {
      "id": "PageChooseAppointmentPhysician",
      "event": "page_choose_appointment_physician",
      "action": "page_view",
      "label": "Behandler und Termin waehlen"
    },
    {
      "id": "PageChoosePhysician",
      "event": "page_choose_physician",
      "action": "page_view",
      "label": "Behandler waehlen"
    },
    {
      "id": "PageChooseReason",
      "event": "page_choose_reason",
      "action": "page_view",
      "label": "Besuchsgrund waehlen"
    }
  ]
}>>


*/
